export enum UnaryConditionType {
    IS_NOT_NULL,
    IS_NULL,
    IS_TRUE,
    IS_FALSE
}
